/**
 * Dialog modal type
 * @public
 */
export const DialogTypes = {
    modal: "modal",
    nonModal: "non-modal",
    alert: "alert"
};
//# sourceMappingURL=dialog.options.js.map